import { Avatar, Box, Button, Card, Container, Flex, Separator, Text, DropdownMenu } from '@radix-ui/themes'
import { useNavigate } from 'react-router-dom'
import { LogOutIcon, UserIcon, SettingsIcon } from 'lucide-react'

import { UpdatesButton, WebsitePromoDialog } from '@/modules/announcements/components'
import { useWebsitePromo } from '@/modules/announcements/hooks'
import { TutorialsButton } from '@/modules/tutorials/components/TutorialsButton'
import { UnifiedNotificationsDropdown } from '@/components/UnifiedNotificationsDropdown'
import { UserProfileRole } from '@/modules/users/types/UserProfile'
import { useUnifiedNotifications } from '@/hooks/useUnifiedNotifications'
import { useAuth } from '@/hooks/useAuth'

export const AppTopBar = () => {
  const { isAuthenticated, isDirty, hasRole, userData } = useAuth()
  const { counts, isConnected, clearNotifications } = useUnifiedNotifications()
  const websitePromo = useWebsitePromo()
  const navigate = useNavigate()

  const handleNavigation = (e: React.MouseEvent) => {
    e.preventDefault()

    if (!isDirty || window.confirm('Tienes datos no guardados. ¿Seguro que quieres salir?')) {
      navigate('/users/sign-out')
    }
  }

  return (
    <Container p="4" flexGrow="0" maxWidth={isAuthenticated ? '100%' : undefined}>
      <Card variant="classic">
        <Flex flexGrow="0" align="center" gap={{ initial: '2', sm: '4' }} justify="between">
          <Flex gap={{ initial: '2', sm: '4' }} align="center">
            <Avatar size="1" src="/images/ic-navbar.png" alt="Veekls" fallback="V" radius="full" />
            {/*
              La fila no envuelve y la Card recorta lo que sobra, sin scroll horizontal: en
              telefonos el titulo y las etiquetas empujaban la campana y el menu de usuario
              fuera de la pantalla, dejandolos inalcanzables. Se necesitaban 646px de ancho, asi que las etiquetas vuelven en sm (768px).
            */}
            <Box display={{ initial: 'none', xs: 'block' }} asChild>
              <Text size="4" weight="bold">
                Dashboard
              </Text>
            </Box>
          </Flex>

          {isAuthenticated ? (
            <Flex align="center" gap={{ initial: '1', sm: '2' }}>
              <UpdatesButton />
              <TutorialsButton />
              {/* Unified Notifications with Bell icon and dropdown */}
              {hasRole(UserProfileRole.AllMessages) && (
                <UnifiedNotificationsDropdown
                  counts={counts}
                  isConnected={isConnected}
                  onClearNotifications={clearNotifications}
                />
              )}
              <Separator orientation="vertical" />

              {/* User Profile Dropdown */}
              <DropdownMenu.Root>
                <DropdownMenu.Trigger>
                  <Button variant="ghost">
                    <UserIcon />
                    <Box display={{ initial: 'none', sm: 'block' }} asChild>
                      <Text>{userData?.user?.firstname}</Text>
                    </Box>
                  </Button>
                </DropdownMenu.Trigger>
                <DropdownMenu.Content>
                  <DropdownMenu.Item onClick={() => navigate(`/users/edit/${userData?.profile?._id}?basic=true`)}>
                    <SettingsIcon />
                    <Text>Editar Perfil</Text>
                  </DropdownMenu.Item>
                  <DropdownMenu.Separator />
                  <DropdownMenu.Item onClick={(e) => handleNavigation(e)}>
                    <LogOutIcon />
                    <Text>Salir</Text>
                  </DropdownMenu.Item>
                </DropdownMenu.Content>
              </DropdownMenu.Root>
            </Flex>
          ) : (
            <Text>Ingreso</Text>
          )}
        </Flex>
      </Card>

      {isAuthenticated && (
        <WebsitePromoDialog
          open={websitePromo.open}
          onDismiss={websitePromo.dismiss}
          onConvert={websitePromo.convert}
        />
      )}
    </Container>
  )
}
